import { CitySelect, CountrySelect, StateSelect } from '@/views/screens/common';
import { Col, Row } from 'antd';
import type { FC } from 'react';
import FormInput from '../../../../../components/Inputs/FormInput';
import FormTextArea from '../../../../../components/Inputs/FormTextArea';
import PostalCodeInput from '../../../../../components/Selectors/PostalCodeInput';

const ClaimsSettingsCarrierAddressForm: FC = () => {
  // TODO: possible bug, investigate missing commented props ClaimsSettingsCarrierAddressForm

  return (
    <Row gutter={15}>
      <Col md={12}>
        <FormInput editMode label="Company Name" margin="mb-10" />
        <FormTextArea editMode label="Address" margin="mb-10" rows={3} />
        <CountrySelect label="Country" editMode margin="mb-10" />
        <PostalCodeInput
          editMode
          label="Postal Code"
          placeholder="Enter postal code"
          margin="mb-10"
          //   handleZipDetails={handleZipDetails}
          //   countryCode={countryCode}
        />
      </Col>
      <Col md={12}>
        <StateSelect
          editMode
          margin="mb-10"
          label="State"
          //   countryCode={countryCode}
        />
        <CitySelect
          editMode
          margin="mb-40"
          name="city"
          //   countryCode={countryCode}
          //   stateCode={stateCode}
        />
        <FormInput
          editMode
          label="Contact Email Address"
          margin="mb-10"
          rules={[
            {
              type: 'email',
              message: 'The input is not valid E-mail!',
            },
          ]}
        />
        <FormInput editMode label="Contact Number" margin="mb-10" />
      </Col>
    </Row>
  );
};

export default ClaimsSettingsCarrierAddressForm;
